
<script setup lang="ts">

import { DealerLocation } from "@app/Components/DealerLocation";
import { useBackButton } from "@app/Components/Utilities";
import { ConditionType } from "@domain/Vehicle/Condition/ConditionType";
import { useVehicleService } from "@app/MyGarage/Services";

useBackButton();

const vehicleService = useVehicleService();
const vehicle = await vehicleService.getActiveVehicle();

</script>

<template>

    <div class="bg-white dark:bg-gray-850 text-gray-800 dark:text-white
                 w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="flex justify-center items-center my-6">
            <strong class="text-lg font-bold">Book a Service</strong>
        </div>     

        <div class="w-full dark:bg-gray-900 h-4 border-b dark:border-b-gray-750">&nbsp;</div>

        <!-- HEADER BRANDING -->
        <!-- <div class="flex flex-col gap-4 lg:gap-6 w-full">
            <div class="overflow-hidden">
                <div class="absolute z-10 left-3 top-3">Suttons Hyundai Arncliffe</div>
                <img src="@/assets/images/help-me/suttons.png"/>
                <JupiterButton type="url"
                               to="https://www.suttonshyundaiarncliffe.com.au"
                               class="v-btn v-theme--theme-carbucks text-secondary v-btn--density-default v-btn--size-small v-btn--variant-text 
                          !absolute z-10 left-3 bottom-3">
                    Visit website
                </JupiterButton>
            </div>
        </div> -->
        
        <div class="w-full dark:bg-gray-900 h-4 border-b dark:border-b-gray-750">&nbsp;</div>

        <!-- NOTIFICATION PANEL -->
        <div class="flex flex-col lg:gap-y-6 w-full
                    mt-6">
            <div class="flex flex-col items-center text-center text-sm lg:text-base mb-3">
                <p class="text-center -mb-3 text-lg">
                    Let's get you booked in for a service
                </p>
            </div>
        </div>
       
        <DealerLocation title="Your Service Location" type="service" />
        
    </div>   
    
</template>
